import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ScanResultsComponent } from './scan-results.component';
import { AuditTypes } from '../../../../../../shared/constants/audit-types';
import { AuditReportWrapperComponent } from '../../../../components/audit-report-wrapper/audit-report-wrapper.component';
import { Api } from '../../../../../../shared/constants/api';
import { AuthGuard } from '../../../../services/auth/guards/auth.guard';
import { IssuesViewComponent } from './issues-view/issues-view.component';
import { ViewScannableDocumentUrlsComponent } from './view-scannable-document-urls/view-scannable-document-urls.component';
import { SecurityGuard } from '../../../../services/auth/guards/security.guard';
import { RequiredSecurities } from '../../../../../../shared/constants/required-securities';
import { featureFlagTranslationResolver } from '../../../../resolvers/feature-flag-translation.resolver';
import { FeatureFlagCollection } from '../../../../../../shared/interfaces/feature-flag.interface';

const routes: Routes = [
  {
    path: '',
    component: ScanResultsComponent,
    data: {
      title: ['sidebar_scan_results'],
      breadcrumbs: {
        isLinkToPageAvailable: true,
      },
    },
  },
  {
    path: `${Api.view_scan_analytics}`,
    loadChildren: (): any =>
      import('app/pages/public/scans/scan-results/view-scan-analytics/view-scan-analytics.module').then(
        (m: any) => m.ViewScanAnalyticsComponentModule,
      ),
    canActivate: [AuthGuard],
    data: {
      title: ['scan_analytics'],
      breadcrumbs: {
        isLinkToPageAvailable: true,
      },
    },
  },
  {
    path: `${Api.aggregated_report}`,
    component: AuditReportWrapperComponent,
    data: {},
    children: [
      {
        path: `:${Api.auditType}/:${Api.ruleId}`,
        component: IssuesViewComponent,
        data: {
          title: ['findings_details'],
          breadcrumbs: {
            isLinkToPageAvailable: true,
          },
        },
      },
    ],
  },
  {
    path: `${Api.scan_point_report}`,
    component: AuditReportWrapperComponent,
    data: {},
    children: [
      {
        path: `:${Api.documentId}/${Api.pages}/:${Api.pageId}`,
        loadChildren: (): any =>
          import('app/pages/public/scans/scan-results/reports/user-flow-scan-point/scan-point-report.module').then(
            (m: any) => m.ScanPointReportModule,
          ),
        resolve: {
          title: featureFlagTranslationResolver(FeatureFlagCollection.userFlowsQ42023Revamp, 'page_report', 'state_report'),
        },
        data: {
          breadcrumbs: {
            isLinkToPageAvailable: true,
          },
        },
      },
    ],
  },
  {
    path: `${Api.component_report}`,
    component: AuditReportWrapperComponent,
    canActivate: [SecurityGuard],
    data: {
      requiredSecurity: RequiredSecurities.Component_Matching_Read,
    },
    children: [
      {
        path: `:${Api.auditType}/:${Api.componentId}`,
        loadChildren: (): any =>
          import('app/pages/public/scans/scan-results/reports/components/scan-component-report.module').then(
            (m: any) => m.ScanComponentReportModule,
          ),
        data: {
          title: ['component_report'],
          breadcrumbs: {
            isLinkToPageAvailable: true,
          },
        },
      },
    ],
  },
  {
    path: `${Api.single_report}`,
    component: AuditReportWrapperComponent,
    data: {},
    children: [
      {
        path: `${AuditTypes.screenshots}/:${Api.documentId}`,
        loadChildren: (): any =>
          import('app/pages/public/scans/scan-results/reports/screenshots/scan-report-screenshots.module').then(
            (m: any) => m.ScanReportScreenshotsModule,
          ),
        data: {
          title: ['scan_report_screenshots'],
          breadcrumbs: {
            isLinkToPageAvailable: true,
          },
        },
      },
      {
        path: `:${Api.auditType}/:${Api.documentId}`,
        loadChildren: (): any =>
          import('app/pages/public/scans/scan-results/reports/accessibility/single-page/scan-single-page-report.module').then(
            (m: any) => m.ScanSinglePageReportModule,
          ),
        data: {
          title: ['scan_page_report_label'],
          breadcrumbs: {
            isLinkToPageAvailable: true,
          },
        },
      },
      {
        path: `:${Api.scannableDocument}`,
        component: ViewScannableDocumentUrlsComponent,
        data: {
          title: ['pdf_discovery_label'],
          breadcrumbs: {
            isLinkToPageAvailable: true,
          },
        },
      },
    ],
  },
  {
    path: `${Api.mobile_app_report}`,
    loadChildren: (): any =>
      import('app/pages/public/scans/scan-results/reports/mobile-app/mobile-app-report.module').then(
        (m: any) => m.MobileAppReportModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScanResultsRoutingModule {}
